"use client";

import type { FC, Ref } from "react";
import { SundialAnalysis, type SundialAnalysisProps } from "@huub-web/shared";

import { useTemplates } from "../../hooks";

export interface AnalysisSundialTemplateProps {
  center: SundialAnalysisProps["center"];
  address: SundialAnalysisProps["address"];
}

/**
 * @deprecated
 */
export const AnalysisSundialTemplate: FC<
  AnalysisSundialTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ center, address, ref }) => {
  const { env } = useTemplates();

  return (
    <SundialAnalysis
      ref={ref}
      container="default"
      center={center}
      address={address}
      accessToken={env.mapBoxToken}
    />
  );
};
